export const ImageStore = {
  sweetPotato: require('../assets/icon/icon-sweet-potato.png'),
  iconChat: require('../assets/icon/icon-chat.svg').default,
  iconBack: require('../assets/icon/icon-back.svg').default,
};

export const thumbnail = {
  road: require('../assets/img/img-road.jpg'),
  wave: require('../assets/img/img-wave.jpg'),
  leaves: require('../assets/img/img-leaves.jpg'),
  sufyan: require('../assets/img/img-sufyan.jpg'),
  sea: require('../assets/img/img-sea.jpg'),
  mountain: require('../assets/img/img-mountain.jpg'),
};
